module.exports = __webpack_public_path__ + "static/media/kinedu_educators_white.940a9e24.png";